"use strict";

document.addEventListener("DOMContentLoaded", () => {
  const drawerIcon = document.querySelector(".drawer__icon");
  if (drawerIcon) {
    drawerIcon.addEventListener("click", () => {
      document.body.classList.toggle("is-openSP");
    });
  }

  // ヘッダー高さを考慮したスムーススクロール
  const header = document.querySelector(".header");
  const getHeaderHeight = () => (header ? header.offsetHeight : 0);

  document.addEventListener("click", (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;

    const url = new URL(link.getAttribute("href"), window.location.href);
    if (!url.hash) return; // ハッシュ無し
    if (url.pathname !== window.location.pathname) return; // 別ページは通常遷移

    const targetEl = document.querySelector(url.hash);
    if (!targetEl) return;

    event.preventDefault();

    const offset = getHeaderHeight();
    const targetTop =
      targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetTop,
      behavior: "smooth",
    });

    // スクロール後はドロワーを閉じる
    document.body.classList.remove("is-openSP");
  });

  // Swiper（トップヒーロー）
  if (typeof Swiper !== "undefined") {
    const heroSlider = document.querySelector(".top-hero__slider");
    if (heroSlider) {
      // eslint-disable-next-line no-unused-vars
      const heroSwiper = new Swiper(heroSlider, {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  }

  // アコーディオン（ナカミライズグループ）
  const accordions = document.querySelectorAll(".js-accordion");
  if (accordions.length) {
    const animTiming = {
      duration: 400,
      easing: "ease-out",
    };

    accordions.forEach((details) => {
      const summary = details.querySelector(".js-accordion-summary");
      const content = details.querySelector(".js-accordion-content");
      if (!summary || !content) return;

      const resetState = () => {
        details.dataset.animStatus = "";
        content.style.height = "";
      };

      summary.addEventListener("click", (event) => {
        event.preventDefault();

        // アニメーション中の連打防止
        if (details.dataset.animStatus === "running") return;

        // 進行中のアニメーションはクリア
        content.getAnimations().forEach((anim) => anim.cancel());

        if (details.open) {
          // 閉じるアニメーション
          details.dataset.animStatus = "running";
          const closingAnim = content.animate(
            [
              { height: `${content.offsetHeight}px`, opacity: 1 },
              { height: "0px", opacity: 0 },
            ],
            animTiming
          );

          closingAnim.onfinish = () => {
            details.removeAttribute("open");
            resetState();
          };
          closingAnim.oncancel = resetState;
        } else {
          // 開くアニメーション
          details.setAttribute("open", "true");
          const targetHeight = content.offsetHeight;
          content.style.height = "0px";
          details.dataset.animStatus = "running";

          const openingAnim = content.animate(
            [
              { height: "0px", opacity: 0 },
              { height: `${targetHeight}px`, opacity: 1 },
            ],
            animTiming
          );

          openingAnim.onfinish = resetState;
          openingAnim.oncancel = resetState;
        }
      });
    });
  }
});
